import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import DatePicker from 'react-datepicker';
import {enUS, ru} from 'date-fns/locale';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {LocaleContext} from '@src/contexts/LocaleContext';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {parseDate, stringifyDate} from '@src/helpers/dates';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import TimeSinceColumn from '@src/components/List/columns/TimeSinceColumn';
import useFormValue from '@src/hooks/useFormValue';

export function DatetimeAtField(props: IListColumnProps) {
    const {rowIndex: index} = props;
    const {
        control,
        fieldName,
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const {locale} = useContext(LocaleContext);
    const [design] = useContext(FormFieldDesignContext);
    const {currentValue} = useFormValue(fieldName ?? '');
    const isExists = Boolean(currentValue?.[index].id);

    if (!control || isExists) {
        return <TimeSinceColumn {...props} forceValue={currentValue?.[index].datetime_at}/>;
    }

    return <>
        <Controller
                name={`${fieldName}.${index}.datetime_at`}
                control={control}
                render={({field: {onChange, onBlur, value}, fieldState: {error}}) => {
                    return <DatePicker
                            selected={value ? parseDate(value).toDate() : undefined}
                            onChange={date => {
                                onChange(date ? stringifyDate(date) as any : null);
                            }}
                            wrapperClassName={classnames({'is-invalid': Boolean(error)})}
                            className={classnames('form-control', 'form-control-sm', {
                                'is-invalid': Boolean(error),
                            })}
                            showTimeInput={true}
                            onBlur={onBlur}
                            locale={{en: enUS, ru: ru}[locale] ?? enUS}
                            dateFormat="Pp"
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            autoComplete="off"
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.datetime_at`}/>
    </>;
}
